enum WidgetType {
  NONE = "NONE",
  TEXT_BOX = "TEXT_BOX",
  TEXT_AREA_SMALL = "TEXT_AREA_SMALL",
  TEXT_AREA_MEDIUM = "TEXT_AREA_MEDIUM",
  TEXT_AREA_LARGE = "TEXT_AREA_LARGE",
  CHECK_VERTICAL = "CHECK_VERTICAL",
  CHECK_HORIZONTAL = "CHECK_HORIZONTAL",
  RADIO_VERTICAL = "RADIO_VERTICAL",
  RADIO_HORIZONTAL = "RADIO_HORIZONTAL",
  IMAGE_SMALL = "IMAGE_SMALL",
  IMAGE_MEDIUM = "IMAGE_MEDIUM",
  IMAGE_LARGE = "IMAGE_LARGE",
  IMAGE_A4 = "IMAGE_A4",
}

export default WidgetType;
